import React, { useState, useEffect, useContext } from 'react';
import './Projects.scss';

import { DataContext } from '../../Contexts/DataContext';

import { motion, AnimatePresence } from 'framer-motion';
import { useHistory } from 'react-router-dom';
import {
  fadeinTop,
  pageTransitions,
  fadeinslow,
  fadeinfast,
} from '../../animations';
import { useInView, InView } from 'react-intersection-observer';
import Tilt from 'react-tilt';

import demoPic from '../../Assets/Icons/demoPic.jpg';
import { projectList } from './ProjectList';

const Projects = (props) => {
  const { projects, skills } = useContext(DataContext);

  const [top, setTop] = useState(0);
  const handleScroll = (e) => {
    setTop(e.target.scrollTop);
  };
  useEffect(() => {
    if (top > 170) props.setDarkenNavbar(true);
    else props.setDarkenNavbar(false);
  }, [top]);

  useEffect(() => {
    console.log('From Prroject Page', projects);
  }, [projects]);

  return (
    <motion.div
      className="Projects_Page"
      variants={pageTransitions}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <div
        className="Projects_Page__page-content Scrollable"
        onScroll={handleScroll}
      >
        <motion.div
          className="Projects_Page__page-content__Title"
          variants={fadeinslow}
          initial="hidden"
          animate="visible"
        >
          <div className="Projects_Page__page-content__Title-heading">
            PROJECTS
          </div>

          <div className="Projects_Page__page-content__Title-details">
            Web Developer | Student | Competitive Programmer
          </div>
        </motion.div>

        <motion.div className="Projects_Page__page-content__Info margin-bottom-big">
          <div className="Projects_Page__page-content__Info__Projects">
            {projects &&
              Object.keys(projects).map((key) => {
                return <Project data={projects[key]} id={key} />;
              })}
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

const Project = ({ data, id }) => {
  const history = useHistory();
  const openProject = (id) => {
    history.push(`/projects/${id}`);
  };

  return (
    <Tilt className="Tilt" options={{ max: 25 }}>
      <div onClick={() => openProject(id)} className="container">
        <div className="inner">
          <img src={data.img} />
          <div>{data.name}</div>
        </div>
      </div>
    </Tilt>
  );
};

export default Projects;
